import scheduleTask from '@afosto/utils-react/tasks/scheduleTask';

const scheduleFileTasks = async requests => {
  try {
    const responses = await Promise.allSettled(requests).then(result =>
      result.filter(promise => promise.status === 'fulfilled'),
    );
    const taskIds = responses
      .map(response => response.value?.headers['x-task-id'])
      .filter(taskId => taskId);

    const taskPromises = taskIds.map(taskId => scheduleTask(taskId));
    const taskResponses = await Promise.allSettled(taskPromises).then(result =>
      result.filter(promise => promise.status === 'fulfilled'),
    );

    return taskResponses.reduce((acc, response) => {
      if (response.value?.result) {
        const file = JSON.parse(response.value.result);

        if (!file?.url) {
          return acc;
        }

        return [...acc, { url: file.url }];
      }

      return acc;
    }, []);
  } catch (err) {
    return Promise.reject(err);
  }
};

export default scheduleFileTasks;
